import { render, staticRenderFns } from "./ShareButton.vue?vue&type=template&id=bdf451cc&scoped=true"
import script from "./ShareButton.vue?vue&type=script&lang=js"
export * from "./ShareButton.vue?vue&type=script&lang=js"
import style0 from "./ShareButton.vue?vue&type=style&index=0&id=bdf451cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf451cc",
  null
  
)

export default component.exports